'use strict';

angular.module('licensure.services')
    .factory('SignalR', ['$rootScope', function ($rootScope) {
        var hubConnection = new signalR.HubConnectionBuilder()
            .withUrl($rootScope.internalURL + "api/messageHub") //This must match the hub route on the backend (defined in Startup)
            .configureLogging(signalR.LogLevel.None)
            .build();

        hubConnection.start().catch(function (err) {
            return console.error(err.toString());
        });

        return {
            onReceiveMessage: function (callback) {
                hubConnection.on("ReceiveMessage", function (message) {
                    // Apply AngularJS digest cycle to make sure the message is updated in the UI
                    $rootScope.$apply(function () {
                        callback(message);
                    });
                });
            },

            getConnectionId: function () {
                if (hubConnection && hubConnection.connection && hubConnection.connection.connectionId) {
                    return hubConnection.connection.connectionId;
                }
                else {
                    return null;
                }
            }
        }
    }])
;